import { Component, Input, OnInit } from '@angular/core';
import { ProjectDto } from '@api/projects/interfaces';
import { UserDto } from '@api/users/interfaces';
import { UserRestService } from '@app/services/rest/user-rest.service';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-project-roles',
	templateUrl: './project-roles.component.html',
	styleUrls: ['./project-roles.component.scss']
})
export class ProjectRolesComponent implements OnInit {

	@Input()
	project: ProjectDto;
	users$: Observable<UserDto[]>;

	constructor(private userRestService: UserRestService) { }

	ngOnInit(): void {
		this.users$ = this.userRestService.listUsers$();
	}
}
